import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import MomentDatePicker from '../MomentDatePicker';

const { TextArea } = Input;

const CurrentMedicationsSection = () => {
  const { t } = useTranslation();

  return (
    <Form.List name="currentMedications">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'medicationName']}
                    label={t('intake.medicalHistory.currentMedications.fields.medicationName')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.currentMedications.validation.medicationNameRequired') },
                      { max: 200, message: t('intake.medicalHistory.currentMedications.validation.medicationNameMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.currentMedications.placeholders.medicationName')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={4}>
                  <Form.Item
                    {...restField}
                    name={[name, 'dosage']}
                    label={t('intake.medicalHistory.currentMedications.fields.dosage')}
                  >
                    <Input placeholder={t('intake.medicalHistory.currentMedications.placeholders.dosage')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'frequency']}
                    label={t('intake.medicalHistory.currentMedications.fields.frequency')}
                  >
                    <Input placeholder={t('intake.medicalHistory.currentMedications.placeholders.frequency')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'route']}
                    label={t('intake.medicalHistory.currentMedications.fields.route')}
                  >
                    <Input placeholder={t('intake.medicalHistory.currentMedications.placeholders.route')} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'startDate']}
                    label={t('intake.medicalHistory.currentMedications.fields.startDate')}
                  >
                    <MomentDatePicker
                      style={{ width: '100%' }}
                      placeholder={t('intake.medicalHistory.currentMedications.placeholders.selectDate')}
                      format="MM/DD/YYYY"
                      disabledDate={(current) => current && current > moment().endOf('day')}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'prescribingProvider']}
                    label={t('intake.medicalHistory.currentMedications.fields.prescribingProvider')}
                  >
                    <Input placeholder={t('intake.medicalHistory.currentMedications.placeholders.prescribingProvider')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={10}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('intake.medicalHistory.currentMedications.fields.notes')}
                  >
                    <TextArea
                      rows={1}
                      placeholder={t('intake.medicalHistory.currentMedications.placeholders.notes')}
                      maxLength={300}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="remove-item-button">
                <Button
                  type="text"
                  danger
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(name)}
                >
                  {t('intake.medicalHistory.currentMedications.buttons.remove')}
                </Button>
              </div>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.currentMedications.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noCurrentMedications')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default CurrentMedicationsSection;
